module.exports = __webpack_public_path__ + "img/ep6-3.3bf9d3ee.png";